import React from 'react';
import PropTypes from 'prop-types';
import { Table, Card } from 'antd';
import GroupButton from './GroupButton';
import SelectableTag from './SelectableTag';
import CardTitle from './CardTitle';
import { DEFAULT_ALERT_SCORES } from './constants';
import { StyledCard } from './styled';

const FilterContent = ({
  onSourceSelection,
  onClear,
  onApply,
  onVisibleChange,
  selectedSourceIds
}) => (
  <StyledCard
    title={<CardTitle onVisibleChange={onVisibleChange} />}
    bordered={false}
    actions={[
      <GroupButton key="group-button" onClear={onClear} onApply={onApply} />
    ]}>
    <Table
      style={{ minWidth: '400px' }}
      rowKey="columnName"
      columns={[
        {
          title: 'Filter',
          dataIndex: 'columnName',
          key: 'columnName'
        },
        {
          title: 'Item',
          key: 'alertSource',
          render: (_, record) => {
            const { alertSource } = record;
            return (
              <SelectableTag
                dataSource={alertSource}
                onChange={onSourceSelection}
                selectedTags={selectedSourceIds}
              />
            );
          }
        }
      ]}
      dataSource={[
        {
          columnName: 'Alert Source',
          alertSource: DEFAULT_ALERT_SCORES
        }
      ]}
      pagination={false}
    />
  </StyledCard>
);

FilterContent.propTypes = {
  onSourceSelection: PropTypes.func,
  onClear: PropTypes.func,
  onApply: PropTypes.func,
  onVisibleChange: PropTypes.func,
  selectedSourceIds: PropTypes.array
};

export default FilterContent;
